export default __webpack_public_path__ + "static/kat-738621c6ab17f406b408b3e8686920fc.jpg";